var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeroImg = function SvgHeroImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-3 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #e5f1fa;\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-19,\n      .cls-6 {\n        opacity: 0.2;\n      }\n\n      .cls-7 {\n        fill: #004d84;\n      }\n\n      .cls-17,\n      .cls-8 {\n        opacity: 0.4;\n      }\n\n      .cls-9 {\n        opacity: 0.35;\n        mix-blend-mode: multiply;\n      }\n\n      .cls-10 {\n        opacity: 0.7;\n      }\n\n      .cls-11 {\n        mask: url(#mask-2);\n      }\n\n      .cls-12,\n      .cls-20 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        mask: url(#mask-3);\n      }\n\n      .cls-15 {\n        mask: url(#mask-4);\n      }\n\n      .cls-16,\n      .cls-17,\n      .cls-18,\n      .cls-19,\n      .cls-20 {\n        fill: #5cf;\n      }\n\n      .cls-16 {\n        opacity: 0.5;\n      }\n\n      .cls-18 {\n        opacity: 0.3;\n      }\n\n      .cls-20 {\n        opacity: 0.1;\n      }\n\n      .cls-21 {\n        fill: #22aac2;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 598.94,
    cy: 648.61,
    r: 519.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 591.46,
    cy: 487.55,
    r: 519.87,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -592.18,
    y: 96.12,
    width: 2372.38,
    height: 1072.36,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.94,
    cy: 648.61,
    r: 519.87
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 14.11,
    y: -32.32,
    width: 1171.26,
    height: 1039.74,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 591.46,
    cy: 487.55,
    r: 519.87
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: -1.46,
    y: -32.32,
    width: 1214.87,
    height: 1039.74,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 591.46,
    cy: 487.55,
    r: 519.87
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 16.77,
    y: -32.32,
    width: 1189.38,
    height: 1039.74,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 591.46,
    cy: 487.55,
    r: 519.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    className: "cls-4",
    width: 1200,
    height: 1200
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M788.37,883.5c.06-.53.13-1.07.21-1.6l-.51.1Q788.23,882.75,788.37,883.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M788.18,897.1a35.45,35.45,0,0,1-4.46,11.24,68.92,68.92,0,0,1,7.17,2.91A67.47,67.47,0,0,1,788.18,897.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M630.3,832.89a72.4,72.4,0,0,1,38.38-2.74,112.89,112.89,0,0,1-15.52-42A92.51,92.51,0,0,1,621,815.25,54.53,54.53,0,0,1,630.3,832.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1259.06,911.91a51.72,51.72,0,0,0-10.25,1,40.11,40.11,0,0,0-74-27.25,86.88,86.88,0,0,0,.79-11.59c0-.66,0-1.32,0-2a69.4,69.4,0,1,0-97.94-84.2,86.57,86.57,0,0,0-46.7,21.29,34.21,34.21,0,0,0-52.24-7.33c-.65-.6-1.32-1.2-2-1.79A93.66,93.66,0,1,0,839.46,684.16a113.16,113.16,0,0,0-62.73-26.8,93.05,93.05,0,0,0,13.49-7.91,115.87,115.87,0,0,0,80.07-58.93,113.7,113.7,0,1,0-28.5-144.07A115.71,115.71,0,0,0,652.6,535.26a92.6,92.6,0,0,0,16,101,37.67,37.67,0,0,0,8.84,62.31,115.17,115.17,0,0,0-8.73,12.25,92.19,92.19,0,0,0-24.94-43.65c0-.3,0-.6,0-.91a137.28,137.28,0,0,0-274.55,0c0,4.18.2,8.32.57,12.41a80.5,80.5,0,0,0-28.91,61.87s0,0,0,.06a66.89,66.89,0,0,0-3.36,11A90.42,90.42,0,0,0,305,749.3a74,74,0,0,0,4.37-117.71,14.41,14.41,0,0,0-14.27-12.44,14.17,14.17,0,0,0-5.1,1,74,74,0,0,0-73.39,10.48A166.52,166.52,0,0,0-108.5,681.23c0,.32,0,.64,0,1-2-.29-4-.49-6-.64a109.35,109.35,0,0,0-96.63-58.11,108.91,108.91,0,0,0-46.39,10.32,114,114,0,0,0-46.69-10A114.49,114.49,0,0,0-418.66,738.3v.19a86.84,86.84,0,0,0-86.67-81.63,86.85,86.85,0,0,0-86.85,86.84,86.87,86.87,0,0,0,68.39,84.86,45,45,0,0,0,43,31.66A44.88,44.88,0,0,0-459.69,855a43,43,0,0,0,5.95,7A112.67,112.67,0,0,0-456.81,888a112.72,112.72,0,0,0,112.72,112.72,112.26,112.26,0,0,0,47-10.27,107,107,0,0,0,63.31,20.63,107.39,107.39,0,0,0,34.79-5.78,80.1,80.1,0,0,0,39.07,22.38,86.27,86.27,0,0,0,86,79.59,86.31,86.31,0,0,0,84.7-69.83A75.31,75.31,0,0,0,128.15,975a76.07,76.07,0,0,0-.84-11.27,108.54,108.54,0,0,0,33.51-17.82,102.49,102.49,0,0,0,112.11,61.35,113.5,113.5,0,0,0,97,14.7A112.88,112.88,0,0,0,533.4,979.7a63.82,63.82,0,0,0,5.94,2.36A39.52,39.52,0,0,0,615.77,962c.5.31,1,.63,1.48.93A21.6,21.6,0,0,0,630,980a76.38,76.38,0,0,0,67.18,40,78,78,0,0,0,12.11-1,69,69,0,0,0,117.9-65.94,67.86,67.86,0,0,0,28.91,6.44,100.18,100.18,0,0,0,125.46-13.37,50.49,50.49,0,0,0,45.55-10.8,86.91,86.91,0,0,0,142.1-28.39,40.09,40.09,0,0,0,40.09,39.41l.87,0a52,52,0,1,0,48.92-34.42ZM-19.48,954.08c-.33-.27-.67-.52-1-.78l1.24-.13C-19.32,953.47-19.4,953.78-19.48,954.08ZM788.37,883.5q-.14-.75-.3-1.5l.51-.1C788.5,882.43,788.43,883,788.37,883.5ZM-132.4,849c0,.88-.07,1.75-.07,2.64a102.69,102.69,0,0,0,1.74,18.68l-.89-.11A107,107,0,0,0-142.43,847,85.15,85.15,0,0,0-132.4,849ZM788.18,897.1a67.47,67.47,0,0,0,2.71,14.15,68.92,68.92,0,0,0-7.17-2.91A35.45,35.45,0,0,0,788.18,897.1Zm-135-109a112.89,112.89,0,0,0,15.52,42,72.4,72.4,0,0,0-38.38,2.74A54.53,54.53,0,0,0,621,815.25,92.51,92.51,0,0,0,653.16,788.12ZM-406,790.61a43.34,43.34,0,0,0-17.76-3.79,43.26,43.26,0,0,0-6.48.49,86.31,86.31,0,0,0,11.73-43A113.9,113.9,0,0,0-406,790.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-9",
    width: 8556,
    height: 3624,
    transform: "translate(-534.12 96.12) scale(0.24)",
    xlinkHref: "tree%20of%20magic-01-011.png"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2.47,663.7A102.69,102.69,0,0,1,.73,645c0-.89.05-1.76.07-2.64a85.15,85.15,0,0,1-10-2,106.53,106.53,0,0,1,10.8,23.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M921.57,676.91c.06-.53.13-1.07.2-1.6l-.5.1Q921.44,676.16,921.57,676.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.71,747.49c.09-.3.17-.61.26-.91l-1.25.13C113.05,747,113.39,747.22,113.71,747.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M921.37,690.51a35.43,35.43,0,0,1-4.45,11.24,68.76,68.76,0,0,1,7.16,2.91A68.12,68.12,0,0,1,921.37,690.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M763.5,626.3a72.4,72.4,0,0,1,38.38-2.74,112.89,112.89,0,0,1-15.52-42,92.64,92.64,0,0,1-32.2,27.13A54.56,54.56,0,0,1,763.5,626.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1392.26,705.32a51.64,51.64,0,0,0-10.25,1,41,41,0,0,0,.56-6.68A40.11,40.11,0,0,0,1308,679.09a88.58,88.58,0,0,0,.79-11.59c0-.66,0-1.31,0-2a69.4,69.4,0,1,0-97.94-84.2,86.5,86.5,0,0,0-46.7,21.29,34.2,34.2,0,0,0-52.24-7.32c-.66-.61-1.33-1.21-2-1.8A93.66,93.66,0,1,0,972.65,477.57a113.13,113.13,0,0,0-62.72-26.8,93.48,93.48,0,0,0,13.48-7.91,115.88,115.88,0,0,0,80.08-58.93A113.69,113.69,0,1,0,975,239.86a115.71,115.71,0,0,0-189.19,88.81,92.65,92.65,0,0,0,16,101A37.66,37.66,0,0,0,810.65,492a113.76,113.76,0,0,0-8.73,12.25A92.13,92.13,0,0,0,777,460.6c0-.3,0-.6,0-.91a137.27,137.27,0,1,0-274.54,0c0,4.18.2,8.32.56,12.41A80.52,80.52,0,0,0,474.1,534V534a67.84,67.84,0,0,0-3.35,11,90.42,90.42,0,0,0-32.52-2.31A74,74,0,0,0,442.59,425a14.39,14.39,0,0,0-14.26-12.44,14.23,14.23,0,0,0-5.11.95A74,74,0,0,0,349.83,424,166.51,166.51,0,0,0,24.7,474.64c0,.32,0,.64,0,1-2-.29-4-.49-6-.64a109.35,109.35,0,0,0-96.63-58.11,108.88,108.88,0,0,0-46.39,10.32,114.09,114.09,0,0,0-46.69-10,114.5,114.5,0,0,0-114.5,114.5c0,.06,0,.13,0,.19a86.85,86.85,0,0,0-86.68-81.63A86.84,86.84,0,0,0-459,537.11,86.86,86.86,0,0,0-390.6,622a45.06,45.06,0,0,0,43,31.66,44.81,44.81,0,0,0,21.08-5.24,43.5,43.5,0,0,0,5.95,7,113.21,113.21,0,0,0-3.06,26.07A112.72,112.72,0,0,0-210.9,794.14a112.3,112.3,0,0,0,47-10.27,106.94,106.94,0,0,0,63.3,20.63,107.35,107.35,0,0,0,34.79-5.78A80.13,80.13,0,0,0-26.74,821.1,86.26,86.26,0,0,0,144,830.86a75.31,75.31,0,0,0,117.39-62.45,76.17,76.17,0,0,0-.84-11.27A108.43,108.43,0,0,0,294,739.32a102.51,102.51,0,0,0,112.12,61.35,113.57,113.57,0,0,0,97,14.71A112.89,112.89,0,0,0,666.6,773.11a63.82,63.82,0,0,0,5.94,2.36A39.52,39.52,0,0,0,749,755.38c.49.31,1,.63,1.48.93a21.57,21.57,0,0,0,12.71,17.08,76.5,76.5,0,0,0,79.3,39,69,69,0,0,0,117.89-65.94,67.91,67.91,0,0,0,28.92,6.44,100.18,100.18,0,0,0,125.46-13.37,50.49,50.49,0,0,0,45.55-10.8,86.9,86.9,0,0,0,142.09-28.39,40.11,40.11,0,0,0,40.09,39.41l.88,0a52,52,0,1,0,48.92-34.42ZM113.71,747.49c-.32-.27-.66-.52-1-.78l1.25-.13C113.88,746.88,113.8,747.19,113.71,747.49Zm807.86-70.58q-.14-.75-.3-1.5l.5-.1C921.7,675.84,921.63,676.38,921.57,676.91ZM.8,642.38c0,.88-.07,1.75-.07,2.64A102.69,102.69,0,0,0,2.47,663.7l-.9-.11a106.53,106.53,0,0,0-10.8-23.21A85.15,85.15,0,0,0,.8,642.38Zm920.57,48.13a68.12,68.12,0,0,0,2.71,14.15,68.76,68.76,0,0,0-7.16-2.91A35.43,35.43,0,0,0,921.37,690.51Zm-135-109a112.89,112.89,0,0,0,15.52,42,72.4,72.4,0,0,0-38.38,2.74,54.56,54.56,0,0,0-9.34-17.64A92.64,92.64,0,0,0,786.36,581.53ZM-272.81,584a43.45,43.45,0,0,0-17.75-3.78,43.39,43.39,0,0,0-6.49.48,86.32,86.32,0,0,0,11.74-43A113.73,113.73,0,0,0-272.81,584Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-9",
    width: 8556,
    height: 3624,
    transform: "translate(-273.24 165.48) scale(0.24)",
    xlinkHref: "tree%20of%20magic-01-012.png"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M263.42,733a102.69,102.69,0,0,1-1.73-18.68c0-.89,0-1.77.06-2.65a83.16,83.16,0,0,1-10-2,107.25,107.25,0,0,1,10.81,23.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1182.52,746.23c.07-.54.13-1.07.21-1.6l-.51.09C1182.34,745.22,1182.43,745.72,1182.52,746.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M374.67,816.8c.08-.3.16-.6.25-.9l-1.24.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1182.33,759.83a35.4,35.4,0,0,1-4.46,11.23A70.31,70.31,0,0,1,1185,774,67.47,67.47,0,0,1,1182.33,759.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1024.45,695.62a72.17,72.17,0,0,1,24.16-4.15,73.18,73.18,0,0,1,14.22,1.4,112.85,112.85,0,0,1-15.52-42A92.73,92.73,0,0,1,1015.12,678,54.53,54.53,0,0,1,1024.45,695.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1653.21,774.64a52.47,52.47,0,0,0-10.25,1,39.7,39.7,0,0,0,.57-6.68A40.11,40.11,0,0,0,1569,748.41a87,87,0,0,0,.79-11.6c0-.66,0-1.31,0-2a69.4,69.4,0,1,0-97.94-84.2,86.65,86.65,0,0,0-46.7,21.3,34.21,34.21,0,0,0-52.24-7.33c-.65-.61-1.32-1.2-2-1.8a93.66,93.66,0,1,0-137.23-115.92,113.16,113.16,0,0,0-62.73-26.8,93.05,93.05,0,0,0,13.49-7.91,115.85,115.85,0,0,0,80.07-58.94,113.7,113.7,0,1,0-28.5-144.07A115.71,115.71,0,0,0,1046.75,398a92.61,92.61,0,0,0,16,101,37.66,37.66,0,0,0,8.84,62.3,115.29,115.29,0,0,0-8.73,12.26,92.19,92.19,0,0,0-24.94-43.65c0-.3,0-.61,0-.91a137.28,137.28,0,1,0-274.55,0c0,4.18.2,8.32.57,12.4a80.52,80.52,0,0,0-28.9,61.88v.06a66.48,66.48,0,0,0-3.36,11,89.93,89.93,0,0,0-32.52-2.3,74,74,0,0,0,4.37-117.72,14.39,14.39,0,0,0-19.37-11.49,74,74,0,0,0-73.39,10.48A166.51,166.51,0,0,0,285.66,544c0,.32,0,.64,0,1-2-.29-4-.5-6-.65a109.4,109.4,0,0,0-143-47.79A114.5,114.5,0,0,0-24.51,601v.2a86.83,86.83,0,0,0-86.67-81.63A86.84,86.84,0,0,0-198,606.43a86.87,86.87,0,0,0,68.38,84.86,45,45,0,0,0,43,31.65,44.88,44.88,0,0,0,21.09-5.24,43.5,43.5,0,0,0,6,7A112.7,112.7,0,0,0,97,853.19,107.44,107.44,0,0,0,195.14,868a79.94,79.94,0,0,0,39.07,22.38,86.27,86.27,0,0,0,170.7,9.77A75.31,75.31,0,0,0,522.3,837.73a76.31,76.31,0,0,0-.84-11.28A108.52,108.52,0,0,0,555,808.64,102.57,102.57,0,0,0,667.08,870a113.62,113.62,0,0,0,97,14.7,112.86,112.86,0,0,0,163.43-42.27,58.72,58.72,0,0,0,5.94,2.36,39.52,39.52,0,0,0,76.43-20.09c.5.31,1,.63,1.48.93a21.59,21.59,0,0,0,12.72,17.08,76.38,76.38,0,0,0,79.29,39,69,69,0,0,0,117.9-65.94,67.87,67.87,0,0,0,28.91,6.45,100.18,100.18,0,0,0,125.46-13.37,50.78,50.78,0,0,0,12.47,1.56,50.25,50.25,0,0,0,33.08-12.37,86.9,86.9,0,0,0,142.1-28.38,40.09,40.09,0,0,0,40.09,39.41l.88,0a52,52,0,1,0,48.91-34.42ZM374.67,816.8l-1-.77,1.24-.13C374.83,816.2,374.75,816.5,374.67,816.8Zm807.85-70.57c-.09-.51-.18-1-.3-1.51l.51-.09C1182.65,745.16,1182.59,745.69,1182.52,746.23ZM261.75,711.69c0,.88-.06,1.76-.06,2.65A102.69,102.69,0,0,0,263.42,733l-.89-.12a107.25,107.25,0,0,0-10.81-23.21A83.16,83.16,0,0,0,261.75,711.69Zm920.58,48.14A67.47,67.47,0,0,0,1185,774a70.31,70.31,0,0,0-7.17-2.92A35.4,35.4,0,0,0,1182.33,759.83Zm-135-109a112.85,112.85,0,0,0,15.52,42,73.18,73.18,0,0,0-14.22-1.4,72.17,72.17,0,0,0-24.16,4.15,54.53,54.53,0,0,0-9.33-17.64A92.73,92.73,0,0,0,1047.31,650.85ZM-11.85,653.34a43.34,43.34,0,0,0-17.76-3.79,44.62,44.62,0,0,0-6.48.48,86.41,86.41,0,0,0,11.74-43A113.77,113.77,0,0,0-11.85,653.34Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars-2",
    "data-name": "stars",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 276.42,
    cy: 103.15,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 47.39,
    cy: 210.23,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 430.49,
    cy: 232.28,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 18.24,
    cy: 382.57,
    r: 2.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 934.36,
    cy: 170.69,
    r: 4.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 205.63,
    cy: 121.16,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 547.09,
    cy: 103.42,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 821.92,
    cy: 602.44,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 201.46,
    cy: 376.06,
    r: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 384.68,
    cy: 193.29,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 438.82,
    cy: 451.87,
    r: 3.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 318.06,
    cy: 579.38,
    r: 2.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1042.62,
    cy: 384.74,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 909.37,
    cy: 562.69,
    r: 4.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 692.83,
    cy: 593.11,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 380.52,
    cy: 246.4,
    r: 3.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 757.79,
    cy: 563.28,
    r: 1.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 686.72,
    cy: 537.85,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 599.62,
    cy: 528.36,
    r: 1.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 520.22,
    cy: 541.34,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 464.49,
    cy: 550.92,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 411.96,
    cy: 542.61,
    r: 3.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 367.56,
    cy: 536.75,
    r: 1.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 416.91,
    cy: 641.54,
    r: 4.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 465.7,
    cy: 618.47,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 560.25,
    cy: 597.5,
    r: 1.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 598.2,
    cy: 551.31,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 643.84,
    cy: 518.43,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 746.12,
    cy: 407.22,
    r: 4.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 600.75,
    cy: 342.67,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 539.04,
    cy: 361.47,
    r: 4.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 472.96,
    cy: 357.44,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 407.29,
    cy: 340.29,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 381.19,
    cy: 474.85,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 441.93,
    cy: 424.07,
    r: 1.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 509.27,
    cy: 429.93,
    r: 1.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 563.87,
    cy: 407.42,
    r: 4.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 646,
    cy: 395.42,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 686.81,
    cy: 363.5,
    r: 2.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 744.25,
    cy: 334.12,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 843.89,
    cy: 290.43,
    r: 2.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 787.88,
    cy: 104.35,
    r: 4.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 719.75,
    cy: 113.66,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 652.75,
    cy: 58.66,
    r: 2.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 563.23,
    cy: 71.51,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 505.54,
    cy: 58.45,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 452.9,
    cy: 81.98,
    r: 2.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 392.53,
    cy: 101.24,
    r: 2.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 341.29,
    cy: 59.41,
    r: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 284.58,
    cy: 104.65,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 212.45,
    cy: 103.72,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 570.73,
    cy: 18.54,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 489.65,
    cy: 5.2,
    r: 2.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 405.52,
    cy: 41.08,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 330.83,
    cy: 21.22,
    r: 3.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 251.05,
    cy: 24,
    r: 1.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 185.72,
    cy: 63.59,
    r: 4.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 91.72,
    cy: 72.53,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 28.39,
    cy: 90.02,
    r: 3.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 15.96,
    cy: 236.04,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 71.54,
    cy: 270.46,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 138.68,
    cy: 256.82,
    r: 4.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 189.5,
    cy: 225.29,
    r: 1.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 249.3,
    cy: 237,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 314.55,
    cy: 228.87,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 373.92,
    cy: 210.44,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 459.42,
    cy: 222.71,
    r: 2.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 511.2,
    cy: 230.76,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 573.62,
    cy: 226.56,
    r: 2.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 635.32,
    cy: 232.84,
    r: 2.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 710.12,
    cy: 267.64,
    r: 3.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 779.69,
    cy: 253.31,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 823.85,
    cy: 293.97,
    r: 4.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 876,
    cy: 327.9,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 856.9,
    cy: 207.04,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 792.43,
    cy: 205.06,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 713.74,
    cy: 173.16,
    r: 3.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 661.76,
    cy: 185.36,
    r: 1.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 590.93,
    cy: 189.23,
    r: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 520.7,
    cy: 166.33,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 457.78,
    cy: 178.79,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 395.72,
    cy: 224.63,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 322.51,
    cy: 223.98,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 254.82,
    cy: 264.38,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 161.28,
    cy: 252.68,
    r: 3.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 105.02,
    cy: 320.86,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 36.93,
    cy: 341.75,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1166.57,
    cy: 291.75,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1102.22,
    cy: 250.99,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1093.12,
    cy: 203.65,
    r: 3.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1047.05,
    cy: 322.23,
    r: 2.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1100.43,
    cy: 323.08,
    r: 1.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1150.09,
    cy: 326.48,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1184.29,
    cy: 407.52,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 73.56,
    cy: 511.66,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 24.49,
    cy: 518.28,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 126.51,
    cy: 748.16,
    r: 3.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 892.71,
    cy: 635.42,
    r: 2.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 522.1,
    cy: 723.17,
    r: 2.11
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars-3",
    "data-name": "stars",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 276.42,
    cy: 15.02,
    r: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 47.39,
    cy: 138.87,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 430.49,
    cy: 175.45,
    r: 3.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 18.24,
    cy: 340.6,
    r: 4.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 934.36,
    cy: 104.96,
    r: 8.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 205.63,
    cy: 39.75,
    r: 4.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 547.09,
    cy: 60.71,
    r: 7.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 821.92,
    cy: 543.31,
    r: 8.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 201.46,
    cy: 297.48,
    r: 3.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 384.68,
    cy: 120.04,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 438.82,
    cy: 370.09,
    r: 6.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 318.06,
    cy: 515.99,
    r: 5.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1042.62,
    cy: 303.54,
    r: 4.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1205.03,
    cy: 159.91,
    r: 8.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 909.37,
    cy: 475.1,
    r: 8.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 692.83,
    cy: 517.13,
    r: 6.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 380.52,
    cy: 199.93,
    r: 6.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 734.4,
    cy: 452.92,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 590.48,
    cy: 518.95,
    r: 3.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 474.34,
    cy: 467.41,
    r: 3.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 392.58,
    cy: 462.59,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 520.44,
    cy: 692.2,
    r: 3.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 616.92,
    cy: 628.07,
    r: 4.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 785.43,
    cy: 503.18,
    r: 5.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 523.92,
    cy: 244.29,
    r: 5.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 387.22,
    cy: 541.62,
    r: 8.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 476.69,
    cy: 461.37,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 634.79,
    cy: 505.15,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 797.09,
    cy: 395.26,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 933.43,
    cy: 96,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 726.51,
    cy: 28.55,
    r: 5.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 575.16,
    cy: 50.98,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 355.45,
    cy: 56.71,
    r: 2.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 211.18,
    cy: 54.86,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 95.39,
    cy: 24.21,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 8.34,
    cy: 353.28,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 122.8,
    cy: 270.21,
    r: 6.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 251,
    cy: 255.83,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 401.7,
    cy: 312.09,
    r: 6.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 497.51,
    cy: 287.88,
    r: 3.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 624.74,
    cy: 291.65,
    r: 8.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 730.33,
    cy: 362.22,
    r: 6.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 793.49,
    cy: 373.47,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 844.82,
    cy: 163.69,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 699.11,
    cy: 124.52,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 550.77,
    cy: 167.44,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 368.78,
    cy: 100.36,
    r: 6.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 220.87,
    cy: 217.24,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 87.67,
    cy: 231.03,
    r: 7.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1117.19,
    cy: 213.54,
    r: 8.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1045.55,
    cy: 422.45,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1117.46,
    cy: 459.66,
    r: 2.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 40.94,
    cy: 494.38,
    r: 7.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1.92,
    cy: 400.48,
    r: 2.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 126.51,
    cy: 699.31,
    r: 6.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 892.71,
    cy: 586.69,
    r: 5.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 522.1,
    cy: 645.56,
    r: 4.22
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars-4",
    "data-name": "stars",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 276.42,
    cy: 124.22,
    r: 3.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 47.39,
    cy: 201.57,
    r: 3.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 430.49,
    cy: 225.53,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 18.24,
    cy: 384.13,
    r: 1.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 934.36,
    cy: 171.19,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 205.63,
    cy: 158.46,
    r: 3.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 547.09,
    cy: 79.48,
    r: 1.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 821.92,
    cy: 587.73,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 201.46,
    cy: 376.05,
    r: 3.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 384.68,
    cy: 206.6,
    r: 1.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 438.82,
    cy: 446.01,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 318.06,
    cy: 556.92,
    r: 2.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1042.62,
    cy: 422.94,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 909.37,
    cy: 576.47,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 692.83,
    cy: 596.68,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 380.52,
    cy: 231.29,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 777.76,
    cy: 545.42,
    r: 2.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 726.25,
    cy: 534.78,
    r: 1.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 666.48,
    cy: 566.02,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 588.97,
    cy: 563.5,
    r: 1.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 507.06,
    cy: 543.79,
    r: 3.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 448.79,
    cy: 547.97,
    r: 2.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 373.62,
    cy: 531.32,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 420.43,
    cy: 604.68,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 477.19,
    cy: 591.88,
    r: 2.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 548.02,
    cy: 560.96,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 642.64,
    cy: 558.83,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 687.04,
    cy: 491.37,
    r: 3.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 624.39,
    cy: 384.88,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 571.65,
    cy: 352.61,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 489.81,
    cy: 372.65,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 409.71,
    cy: 352.51,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 370.5,
    cy: 467.6,
    r: 1.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 429.87,
    cy: 470.32,
    r: 3.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 476.57,
    cy: 415.88,
    r: 1.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 551.81,
    cy: 433.87,
    r: 2.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 610.5,
    cy: 411.95,
    r: 4.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 687.1,
    cy: 376.28,
    r: 4.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 735.22,
    cy: 322.75,
    r: 2.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 811.49,
    cy: 303.79,
    r: 1.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 848.92,
    cy: 150.98,
    r: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 725.45,
    cy: 98.99,
    r: 3.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 662.24,
    cy: 86.78,
    r: 2.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 589.15,
    cy: 80.38,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 500.28,
    cy: 58.36,
    r: 2.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 447.47,
    cy: 70.67,
    r: 2.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 366.44,
    cy: 93.4,
    r: 3.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 292.8,
    cy: 109.08,
    r: 2.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 212.57,
    cy: 108.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 590.32,
    cy: 45.7,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 505.87,
    cy: 32.69,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 440.21,
    cy: 27.26,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 351.32,
    cy: 49.71,
    r: 2.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 276.46,
    cy: 39.69,
    r: 4.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 200.44,
    cy: 46.53,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 135.61,
    cy: 82.34,
    r: 1.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 35.02,
    cy: 71.81,
    r: 3.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 32.47,
    cy: 233.52,
    r: 2.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 112.95,
    cy: 230.22,
    r: 4.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 197.98,
    cy: 254.13,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 257.3,
    cy: 232.99,
    r: 4.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 313.66,
    cy: 238.67,
    r: 2.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 372.69,
    cy: 242.31,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 457.3,
    cy: 232.45,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 539.45,
    cy: 237.13,
    r: 3.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 618.3,
    cy: 214.71,
    r: 1.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 674.83,
    cy: 265.59,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 747.24,
    cy: 266.27,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 794.54,
    cy: 278.91,
    r: 3.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 841.23,
    cy: 308.76,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 911.73,
    cy: 170.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 829.97,
    cy: 204.75,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 742.28,
    cy: 187.41,
    r: 3.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 653.84,
    cy: 162.96,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 577.24,
    cy: 177.05,
    r: 4.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 510.66,
    cy: 181.06,
    r: 2.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 433.58,
    cy: 174.62,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 360.71,
    cy: 194.08,
    r: 4.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 279.54,
    cy: 206.56,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 225.53,
    cy: 233.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 151.55,
    cy: 253.91,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 97.01,
    cy: 323.53,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 44.6,
    cy: 368.93,
    r: 4.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1201.78,
    cy: 298.61,
    r: 4.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1156.25,
    cy: 269.64,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1131.8,
    cy: 228.56,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1060.85,
    cy: 254.99,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1078.73,
    cy: 292.13,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1112.05,
    cy: 354.7,
    r: 4.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1156.31,
    cy: 380.67,
    r: 3.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 53.61,
    cy: 537.9,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 126.51,
    cy: 735.05,
    r: 2.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 892.71,
    cy: 637.28,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 522.1,
    cy: 754.52,
    r: 3.98
  })))), /*#__PURE__*/React.createElement("path", {
    id: "hill",
    className: "cls-4",
    d: "M1200,874.62,734.23,784.85c-77.43-14.93-271-14.93-348.42,0L2.47,858.73v233H1200Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circ-1",
    className: "cls-16",
    cx: 557.76,
    cy: 546.94,
    r: 77.21
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circ-2",
    className: "cls-17",
    cx: 557.76,
    cy: 546.94,
    r: 100.37
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circ-3",
    className: "cls-18",
    cx: 557.76,
    cy: 546.94,
    r: 130.49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circ-4",
    className: "cls-19",
    cx: 557.76,
    cy: 546.94,
    r: 169.63
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circ-5",
    className: "cls-20",
    cx: 557.76,
    cy: 546.94,
    r: 220.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "fruit",
    className: "cls-21",
    cx: 560.09,
    cy: 546.94,
    rx: 27.14,
    ry: 33.23
  }), /*#__PURE__*/React.createElement("g", {
    id: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "branch",
    className: "cls-4",
    d: "M332.14,495.69c-2.64-10.79-3.7-22.32-7.17-32.74-9.56-9.56-13.69-23.21-1.72-31.14,5.4-1.13,12.31-2.58,15.27-6.94,3.44-3.53,18.26-14.35,60.73-42.25,8.17-8.75,44.15-31.62,43.53-40.19-6-21.54,31.8-27.36,34.55-.61,3.87,24.05,52.51,54.12,72.31,68.62,5.35,1.21,10.22-.63,15.83,4.25,4.93,3,6.55,13.74-1.23,17.18a2.58,2.58,0,0,0-1.31,2.25c.07,22.37.08,39.06-.24,47.66-.56,8,2.34,12.32,11.34,19.67,14.16,13.24,14.1,11.74,17.35,23.59,1.72,3.72-3,20.15-9.49,10.88-1.48-2.32-.62-5.75-1.83-9.1a2.57,2.57,0,0,0-4.86-.19c-.61,6.71-4.08,12-10.42,4.89-2.81-3.76-1.7-14.16-8.64-15.1-6,1.92-5.21,3.64-7.79,8.39-3.18,7-17.36,11.79-15-1.39.52-2.94.7-2,3.18-6.13,4.64-7.65,5.53-7.19,6.77-8.21,3.76-3.07,6-2.1,7.87-4.62,2.45-3.29,1.1-8.1.69-9.72-1.92-7.69-3.62-28-4.59-58.75a17.88,17.88,0,0,0-1.66-11.12c-9.85-13.46-37.92-22-60.61-41.87-9.84-10.77-9.74-15.05-23.72-24.89-7.19-2.71-20.8,8.85-22.31,12.86-6.14,8.75-15.59,15.62-34.47,29.38-5.27,4.45-31.63,19.58-44.88,32.16-19.85,14.58-12.34,39.7-1.86,60.84C366,506,371.86,516,367,526.9c-1.51,2.06-4,4.16-6.09,2.07C351.49,517.78,341,507.22,332.14,495.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "branch-2",
    "data-name": "branch",
    className: "cls-4",
    d: "M316.45,623.75c-13.92,4.38,22.8,12.94,8,21.45-5.5,5.39-.76,22.6,2.24,25.67,5.34,9.25,7.59,20.72,12.09,43.65,1.81,6.65,4.4,36.93,10.2,54.26,4.85,24.15,30.79,27.94,54.38,27.36,15-2.12,26.49-3.26,34.32,5.77,1.23,2.23,2.09,5.37-.69,6.39-14.12,3.8-28.12,8.86-42.31,12-10.89-2.16-21.79-6.07-32.7-7.32-12.71,4.63-26.83,2.61-29-11.59,1.26-5.37,2.86-12.24.16-16.77-1.75-4.61-5.3-22.61-12.68-72.89-4.48-11.1-10-53.37-18.06-56.43-22.05-3.67-11.38-40.37,14-31.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "branch-3",
    "data-name": "branch",
    className: "cls-4",
    d: "M368.38,506c-13.45-5.66,9,24.61-7.79,21.52-7.67.55-15.2,16.74-14.89,21-1.92,10.51-7.62,20.71-19,41.11-2.92,6.24-20.53,31-27.31,48-11.92,21.55,5.41,41.23,23.78,56,12.77,8.07,22.31,14.65,22.44,26.6-.51,2.5-1.88,5.45-4.66,4.42-13.23-6.23-27.18-11.42-40-18.19-6.91-8.7-12.7-18.73-20.21-26.74-12.69-4.68-22.15-15.36-14.59-27.56,4.43-3.29,10.1-7.49,11-12.69,1.64-4.65,10.58-20.68,37.47-63.79,3.77-11.37,26.88-47.19,22.73-54.72-14.44-17.06,17.43-38.15,31.12-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "branch-4",
    "data-name": "branch",
    className: "cls-4",
    d: "M302.4,646.71c-13.92,4.39,22.79,12.94,8,21.46-5.49,5.38-.75,22.6,2.25,25.66,5.33,9.26,7.58,20.72,12.08,43.65,1.81,6.65,4.4,36.93,10.21,54.26,4.85,24.15,30.78,27.94,54.38,27.36,15-2.11,26.48-3.26,34.31,5.77,1.24,2.24,2.09,5.37-.69,6.39-14.12,3.8-28.12,8.86-42.3,12-10.9-2.16-21.8-6.07-32.71-7.32-12.7,4.64-26.82,2.61-28.95-11.59,1.25-5.37,2.85-12.24.15-16.77-1.75-4.6-5.3-22.61-12.68-72.88-4.48-11.11-10-53.37-18.05-56.43-22.05-3.68-11.38-40.37,14-31.58"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HeroImg.1d9b94ee.svg";
export { ForwardRef as ReactComponent };